import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/NodeRender/NodeRender.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isBimNode } from "../../../classifier-service/Node";
import { LoadMoreContent } from "../nodes/LoadMoreContent";
import { ReferenceNodeContent } from "../nodes/ReferenceNodeContent";
import { UserClassifierNodeContent } from "../nodes/UserClassifierNodeContent";
import { BimNodeContent } from "../nodes/BimNodeContent";
import { GroupNodeContent } from "../nodes/GroupNodeContent";
import { DynamicGeneratedGroupNodeContent } from "../nodes/DynamicGeneratedGroupNodeContent";
import { jsx as _jsx } from "react/jsx-runtime";
export var NodeRender = function NodeRender(props) {
  var node = props.node,
      path = props.path,
      onLoadMore = props.onLoadMore,
      inSearch = props.inSearch,
      onPending = props.onPending;

  switch (node.type) {
    case 'LoadMore':
      return /*#__PURE__*/_jsx(LoadMoreContent, {
        inSearch: inSearch,
        node: node,
        path: path,
        onLoadMore: onLoadMore,
        onPending: onPending
      });

    case 'ReferenceNode':
      return /*#__PURE__*/_jsx(ReferenceNodeContent, _objectSpread(_objectSpread({}, props), {}, {
        node: node
      }));

    case 'AnonymousClassifierNode':
    case 'UserClassifierNode':
      return /*#__PURE__*/_jsx(UserClassifierNodeContent, _objectSpread(_objectSpread({}, props), {}, {
        node: node
      }));

    case 'UserClassifierGroupNode':
      return /*#__PURE__*/_jsx(GroupNodeContent, _objectSpread(_objectSpread({}, props), {}, {
        node: node
      }));

    case 'DynamicGeneratedGroupNode':
      return /*#__PURE__*/_jsx(DynamicGeneratedGroupNodeContent, _objectSpread(_objectSpread({}, props), {}, {
        node: node
      }));
  }

  if (isBimNode(node)) {
    return /*#__PURE__*/_jsx(BimNodeContent, _objectSpread(_objectSpread({}, props), {}, {
      node: node
    }));
  }

  throw new Error('[NodeRender]: not handled node');
};